<div class="tabs-container">
  @if (tabSegmented()) {
    <ng-template #segmentedControl>
      <div
        data-segmented-control
        class="flex flex-wrap items-center gap-x-sm rounded-lg p-x-sm"
        [class]="segmentedClass()"
        (click)="preventSwitchTabs() && discard.emit()">
        @for (tab of tabs(); track $index; let i = $index) {
          <button
            type="button"
            class="min-w-[3.125rem] py-sm px-md rounded-md text-sm focus-visible:ring-2 focus-visible:ring-updated-primary-300"
            libPermissions
            [featurePermissions]="tab.featurePermissions()"
            [userPermissions]="tab.userPermissions()"
            [attr.aria-pressed]="tab.active()"
            [class.text-neutral-300]="tab.disable()"
            [class.bg-white]="tab.active() === true"
            [class.shadow-sm]="tab.active() === true"
            [class.font-semibold]="tab.active() === true"
            [class.text-neutral-900]="tab.active() === true"
            [class.font-medium]="tab.active() !== true"
            [class.text-neutral-700]="tab.active() !== true && !tab.disable()"
            (click)="onTabClick(tab, $index)">
            <div class="flex items-center gap-sm">
              @if (tab.tabDefaultIcon()) {
                <img
                  [src]="
                    tab.active() ? tab.tabActiveIcon() : tab.tabDefaultIcon()
                  "
                  class="size-4"
                  [alt]="tab.tabTitle()" />
              }

              @if (tab.tabTemplateSvgIcon()) {
                <span class="inline-flex">
                  <ng-container [ngTemplateOutlet]="tab.tabTemplateSvgIcon()" />
                </span>
              }

              <span>{{ tab.tabTitle() }}</span>

              @if (tab.showTabTag()) {
                <span data-tab-count class="font-normal text-neutral-500">
                  {{ tab.tabTag() }}
                </span>
              }
            </div>
          </button>
        }
      </div>
    </ng-template>

    @if (tabsStartRef()) {
      <!-- Page title and its actions on one row, the tabs on their own row below -->
      <div class="flex flex-col gap-lg mb-lg" [class]="tabsHeaderClass()">
        <div class="flex flex-wrap items-center justify-between gap-lg">
          <div class="flex items-center min-w-0">
            <ng-container [ngTemplateOutlet]="tabsStartRef()" />
          </div>
          <div class="flex items-center">
            <ng-container [ngTemplateOutlet]="tabActionSectionRef()" />
          </div>
        </div>
        <div class="flex">
          <ng-container [ngTemplateOutlet]="segmentedControl" />
        </div>
      </div>
    } @else {
      <div
        class="flex flex-wrap items-center justify-between gap-lg mb-lg"
        [class]="tabsHeaderClass()">
        <ng-container [ngTemplateOutlet]="segmentedControl" />
        <div class="flex items-center">
          <ng-container [ngTemplateOutlet]="tabActionSectionRef()" />
        </div>
      </div>
    }
  } @else {
    <div
      class="flex items-center justify-between"
      [class]="tabsHeaderClass()"
      [class.gap-md]="tabPill()"
      [class.border-b]="tabsBorder()"
      [class.border-neutral-300]="tabsBorder()">
      @if (tabsStartRef()) {
        <div class="flex items-center shrink-0">
          <ng-container [ngTemplateOutlet]="tabsStartRef()" />
        </div>
      }
      <div
        class="nav-tabs flex flex-wrap items-center list-none"
        [class.ms-auto]="!!tabsStartRef()"
        (click)="preventSwitchTabs() && discard.emit()"
        [class]="tabsClass()">
        @for (tab of tabs(); track $index) {
          <button
            type="button"
            class="min-w-[3.125rem]"
            libPermissions
            [featurePermissions]="tab.featurePermissions()"
            [userPermissions]="tab.userPermissions()"
            [class.border-b-2]="tab.active() === true && !tabPill()"
            [class.border-solid]="tab.active() === true && !tabPill()"
            [class.border-primary-500]="
              tab.active() === true && !tabPill() && !systemDefaultColor()
            "
            [class.border-primary-900]="
              tab.active() === true && !tabPill() && systemDefaultColor()
            "
            [class.text-neutral-300]="tab.disable()"
            [class.rounded-md]="tabPill()"
            [class.text-neutral-700]="
              tabPill() && !(tab.active() && systemDefaultColor())
            "
            [class.text-primary-700]="
              tab.active() === true && tabPill() && !systemDefaultColor()
            "
            [class.bg-primary-50]="
              tab.active() === true && tabPill() && !systemDefaultColor()
            "
            [class.text-white]="
              tab.active() === true && tabPill() && systemDefaultColor()
            "
            [class.bg-primary-800]="
              tab.active() === true && tabPill() && systemDefaultColor()
            "
            [class.py-sm]="tabPill()"
            [class.px-md]="tabPill()"
            [class.p-lg]="!tabPill()"
            (click)="onTabClick(tab, $index)">
            <div class="flex items-center gap-sm">
              @if (tab.tabDefaultIcon()) {
                <img
                  [src]="
                    tab.active() ? tab.tabActiveIcon() : tab.tabDefaultIcon()
                  "
                  class="size-4"
                  [alt]="tab.tabTitle()" />
              }

              @if (tab.tabTemplateSvgIcon()) {
                <span
                  [class]="
                    tab.active() && systemDefaultColor() && tabPill()
                      ? 'inline-flex [&_svg]:!text-white'
                      : 'inline-flex'
                  ">
                  <ng-container [ngTemplateOutlet]="tab.tabTemplateSvgIcon()" />
                </span>
              }

              <span
                class="font-medium"
                [class.text-xs]="tabPill()"
                [class.text-sm]="!tabPill()"
                [class.text-primary-700]="tab.active() && !systemDefaultColor()"
                [class.text-white]="
                  tab.active() && systemDefaultColor() && tabPill()
                "
                [class.text-primary-900]="
                  tab.active() && systemDefaultColor() && !tabPill()
                "
                [class.text-neutral-700]="!tab.active()">
                {{ tab.tabTitle() }}
              </span>

              @if (tab.showTabTag()) {
                <span
                  class="text-xs font-medium rounded-2xl px-sm"
                  [class.bg-neutral-50]="tab.active() !== true"
                  [class.text-neutral-700]="tab.active() !== true"
                  [class.bg-primary-100]="
                    tab.active() === true && !systemDefaultColor()
                  "
                  [class.text-primary-700]="
                    tab.active() === true && !systemDefaultColor()
                  "
                  [class.bg-neutral-600]="
                    tab.active() === true && systemDefaultColor()
                  "
                  [class.text-neutral-100]="
                    tab.active() === true && systemDefaultColor()
                  ">
                  {{ tab.tabTag() }}
                </span>
              }
            </div>
          </button>
        }
      </div>

      <div class="flex items-center">
        <ng-container [ngTemplateOutlet]="tabActionSectionRef()" />
      </div>
    </div>
  }

  <div class="custom-height" [class]="tabsContentClass()">
    <ng-content />
  </div>
</div>
